import React from "react";
import { CheckIcon, MinusIcon } from "lucide-react";
import { audienceNo, audienceYes } from "../data/pains";
export function AudienceSection() {
  return <section className="bg-sand py-20 md:py-28" aria-labelledby="audience-title" data-id="element-13" data-mp="n3kv2u2j0m8c">
      <div className="mx-auto max-w-6xl px-5" data-id="element-14" data-mp="s1e21pbnlk9o">
        <h2 id="audience-title" className="font-display text-4xl uppercase leading-none text-ink md:text-6xl" data-id="element-15" data-mp="x07j1rq5ftel">
          Pour qui est ce pack ?
        </h2>
        <div className="mt-14 grid gap-12 md:grid-cols-[1.4fr_1fr] md:gap-20" data-id="element-16" data-mp="4b0b624t1rgo">
          <div data-id="element-17" data-mp="48nt7oz1rh3m">
            <h3 className="font-serif text-2xl text-walnut" data-id="element-18" data-mp="9a3bxadr5biu">C'est pour vous si vous êtes…</h3>
            <ul className="mt-6 space-y-5" data-id="element-19" data-mp="e0tigqxwzkf4">
              {audienceYes.map(item => <li key={item} className="flex gap-4 text-lg text-ink" data-id="element-20" data-mp="e2mtsjjh2stg">
                  <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-walnut" aria-hidden="true" data-id="element-21" data-mp="3cqaflgw638rm" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="border-t border-walnut/15 pt-10 md:border-l md:border-t-0 md:pl-12 md:pt-0" data-id="element-22" data-mp="149hlu3spqo4l">
            <h3 className="font-serif text-2xl text-stone" data-id="element-23" data-mp="zc9c8rlmrsey">Ce n'est pas pour…</h3>
            <ul className="mt-6 space-y-5" data-id="element-24" data-mp="ujy0mrhj2i6k">
              {audienceNo.map(item => <li key={item} className="flex gap-4 text-stone" data-id="element-25" data-mp="qk7bstbkac4o">
                  <MinusIcon className="mt-1 h-5 w-5 shrink-0" aria-hidden="true" data-id="element-26" data-mp="lkb7su2v6kp4" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}